"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _reactRouterDom = require("react-router-dom");

var _Popover = _interopRequireDefault(require("../Popover"));

var _PrimaryButton = require("./PrimaryButton");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _descriptor, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Button = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    (0, _classCallCheck2["default"])(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "mouseDown", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Button, [{
    key: "renderButton",
    value: function renderButton() {
      var _this2 = this;

      var _this$props = this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          borderRadius = _this$props.borderRadius,
          className = _this$props.className,
          style = _this$props.style,
          text = _this$props.text,
          rel = _this$props.rel,
          href = _this$props.href,
          target = _this$props.target,
          textColor = _this$props.textColor,
          borderColor = _this$props.borderColor,
          backgroundColor = _this$props.backgroundColor,
          hoverBackgroundColor = _this$props.hoverBackgroundColor,
          isRouterLink = _this$props.isRouterLink,
          hideBorder = _this$props.hideBorder,
          popoverContent = _this$props.popoverContent,
          popoverContentWidth = _this$props.popoverContentWidth,
          popoverPosition = _this$props.popoverPosition,
          _this$props$openInNew = _this$props.openInNewTab,
          openInNewTab = _this$props$openInNew === void 0 ? false : _this$props$openInNew,
          children = _this$props.children,
          minWidth = _this$props.minWidth,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["disabled", "onClick", "borderRadius", "className", "style", "text", "rel", "href", "target", "textColor", "borderColor", "backgroundColor", "hoverBackgroundColor", "isRouterLink", "hideBorder", "popoverContent", "popoverContentWidth", "popoverPosition", "openInNewTab", "children", "minWidth"]);

      if (href != null && !disabled) {
        var onClickValue = disabled ? undefined : onClick;

        var linkProps = _objectSpread({
          className: (0, _styling.css)(this.styles.root, !disabled && "ripple-ink"),
          onClick: function onClick() {
            return onClickValue && onClickValue();
          },
          onMouseUp: function onMouseUp() {
            return _this2.mouseDown = false;
          },
          onMouseDown: function onMouseDown() {
            return _this2.mouseDown = true;
          }
        }, props);

        if (isRouterLink) {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, (0, _extends2["default"])({}, linkProps, {
            to: href
          }), text || children);
        }

        var onClickHandler = function onClickHandler(e) {
          if (href) {
            var navigator = new _providers.LegoNavigator(_this2.context);
            navigator.navigate(href, {
              openInNewTab: openInNewTab
            });
            e.preventDefault();
          }

          if (onClickValue) {
            onClickValue();
          }
        };

        linkProps = _objectSpread(_objectSpread({}, linkProps), {}, {
          onClick: onClickHandler
        });
        return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({}, linkProps, {
          href: href
        }), text || children);
      }

      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        className: (0, _styling.css)(this.styles.root, !disabled && "ripple-ink"),
        onClick: disabled || !onClick ? function () {} : onClick,
        onMouseUp: function onMouseUp() {
          return _this2.mouseDown = false;
        },
        onMouseDown: function onMouseDown() {
          return _this2.mouseDown = true;
        }
      }, props), text || children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          popoverContent = _this$props2.popoverContent,
          popoverPosition = _this$props2.popoverPosition,
          className = _this$props2.className,
          style = _this$props2.style,
          popoverContentWidth = _this$props2.popoverContentWidth,
          popoverMouseEnterDelay = _this$props2.popoverMouseEnterDelay;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.container, className, style)
      }, popoverContent ? /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        position: popoverPosition || "top center",
        popoverMaxWidth: 250,
        popoverContent: popoverContent,
        contentWidth: popoverContentWidth,
        popoverMouseEnterDelay: popoverMouseEnterDelay
      }, this.renderButton()) : this.renderButton());
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          surfaceLightest = _this$context$theming2.surfaceLightest,
          borderPrimary = _this$context$theming2.borderPrimary,
          textDark = _this$context$theming2.textDark,
          fonts = _this$context$theming.fonts;
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          borderRadius = _this$props3.borderRadius,
          fontSize = _this$props3.fontSize,
          padding = _this$props3.padding,
          hideBorder = _this$props3.hideBorder,
          textColor = _this$props3.textColor,
          borderColor = _this$props3.borderColor,
          backgroundColor = _this$props3.backgroundColor,
          hoverBackgroundColor = _this$props3.hoverBackgroundColor,
          minWidth = _this$props3.minWidth;
      var hoverBackground = hoverBackgroundColor ? hoverBackgroundColor : "rgb(249, 249, 249)";
      return _aphrodite.StyleSheet.create({
        root: {
          // prop is controlled by parent
          // eslint-disable-next-line local-rules/validate-root
          minWidth: !!minWidth ? _PrimaryButton.MIN_WIDTH_VALUE - 52 : undefined,
          display: "flex",
          userSelect: "none",
          alignItems: "center",
          justifyContent: "center",
          cursor: disabled ? "default" : "pointer",
          fontSize: fontSize != null ? fontSize : 15,
          flexDirection: "column",
          padding: padding,
          width: "inherit",
          flex: 1,
          textRendering: "optimizeSpeed",
          overflow: "hidden",
          fontFamily: fonts.regular,
          transition: "all 0.3s linear",
          transitionProperty: "opacity, background-color, box-shadow",
          borderRadius: borderRadius != null ? borderRadius : 3,
          opacity: disabled ? 0.4 : 0.8,
          boxShadow: !hideBorder ? "0 1px 0 0 rgba(22, 29, 37, 0.05)" : undefined,
          backgroundColor: backgroundColor ? backgroundColor : surfaceLightest,
          border: !hideBorder ? "solid 1px ".concat(borderColor ? borderColor : borderPrimary) : undefined,
          color: textColor ? textColor : textDark,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          textDecoration: "none",
          ":hover": {
            opacity: !disabled ? 1 : undefined,
            backgroundColor: !disabled ? hoverBackground : undefined,
            boxShadow: !disabled ? "0 1px 0 0 rgba(22, 29, 37, 0.1)" : undefined
          }
        },
        container: {
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch"
        }
      });
    }
  }]);
  return Button;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  onClick: {
    required: false,
    defaultValue: "null",
    type: "?() => void",
    description: "Optional callback for button click"
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates if the button is disabled"
  },
  href: {
    required: false,
    defaultValue: "null",
    type: "(string | null)",
    description: "If button is a link, set this to the `href` value"
  },
  target: {
    required: false,
    defaultValue: "null",
    type: "(string | null)",
    description: "If button is a link, set this to the `target` value"
  },
  text: {
    required: false,
    defaultValue: "null",
    type: "string",
    description: "Text of the button. Text can also be " + "rendered as a child of the button\n      `<Button>Click me</Button>`\n       "
  },
  textColor: {
    required: false,
    defaultValue: "theme's `textDark`",
    type: "(string | null)",
    description: "Color of the text"
  },
  borderColor: {
    required: false,
    defaultValue: "theme's `borderPrimary`",
    type: "(string | null)",
    description: "Color of the border"
  },
  padding: {
    required: false,
    defaultValue: "5px 25px",
    type: "string",
    description: "Internal padding of the button"
  },
  fontSize: {
    required: false,
    defaultValue: "15",
    type: "number",
    description: "Internal font size of the button"
  },
  popoverContent: {
    required: false,
    defaultValue: "null",
    type: "(string | null) | ((() => ReactNode))",
    description: "Set if the button displays a popover when hovered. Value is the " + "popover's content: either string or a custom render function "
  },
  popoverPosition: {
    required: false,
    defaultValue: "top center",
    type: "(string | null)",
    description: "Position of the button's popover -- if it has one"
  },
  isRouterLink: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "If the button is being used as a link, use this value to " + "indicate if it is an internally handled link. Internal links " + "are handled by JS and do not refresh the page"
  },
  minWidth: {
    required: false,
    defaultValue: "false",
    type: "boolean | undefined | null",
    description: "Controls whether the button has a default min width, currently ".concat(_PrimaryButton.MIN_WIDTH_VALUE)
  },
  download: {
    required: false,
    defaultValue: "boolean",
    type: "boolean | undefined | null",
    description: "Indicates if this is a download link"
  }
}, _class3.demoProps = {
  href: "http://www.google.com"
}, _class3.demoRender = "\n<Button\n  onClick={() => {}}\n  disabled={false}\n  padding=\"7px 15px\"\n>\nClick Me\n</Button>\n", _class3.defaultProps = {
  disabled: false,
  borderRadius: 4,
  padding: "5px 25px"
}, _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "mouseDown", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = Button;
exports["default"] = _default;